<template>
    <v-layout row>
        <v-flex class="pl-2">
            <v-text-field
                    clearable
                    color="primary"
                    flat
                    v-model="value.value"
                    hide-details
                    class="pa-0 ma-0"
                    single-line
                    :label="value.fieldDescription"
                    type="number"
                    :readonly="readOnly"
                    @keydown.enter="$emit('forceSave')"
            >
            </v-text-field>
        </v-flex>
    </v-layout>
</template>

<script>
    export default {
        props: {
            value: Object,
            readOnly: Boolean
        }
    }
</script>

<style scoped>

</style>
